
import { historicalDataLiveStatusSummary } from "../types/types";
import { ChannelkartNetworkGet } from "./networkService";
import dayjs from 'dayjs';


export async function fetchHistoricalLiveSummary(env: string, lob: string): Promise<historicalDataLiveStatusSummary> {
  try {
    const response = await ChannelkartNetworkGet(`https://analytics.sellina.io/historicalLiveStatus?env=${env}&lob=${lob}`);
   // const response = await ChannelkartNetworkGet(`http://localhost:3001/historicalLiveStatus?env=local&lob=kbpldemo&source=portal`);
  
    if (response.data) {
      const processed = processSyncSummary(response.data.data);

      return {
        tableWise: processed.tableWise,
        liveStatus: processed.liveStatus,
      };
    }
    return {
      tableWise: [],
      liveStatus: []
    };
  } catch (err) {
    return {
      tableWise: [],
      liveStatus: []
    };
  }
}

// Update the processSyncSummary function to return properly typed data
const processSyncSummary = (data: any[]): historicalDataLiveStatusSummary => {
  const today = dayjs().format('YYYY-MM-DD');

  const tableWiseData: Record<string, {
    taskDate: string;
    groupItems: any[];
  }> = {};

  const liveStatusMap = new Map<string, {
    tableName: string;
    totalRecordCount: number;
    lastSyncDateTime: string;
    lastSyncRecordCount: number;
    lastSyncStatus: string;
  }>();

  for (const record of data) {
    const dateKey = dayjs(record.taskdate).format('YYYY-MM-DD');
    const tableName = record.table_name;

    // For table-wise grouping
    if (!tableWiseData[dateKey]) {
      tableWiseData[dateKey] = {
        taskDate: dateKey,
        groupItems: []
      };
    }
    tableWiseData[dateKey].groupItems.push(record);

    // Only consider records for today in liveStatus
    if (dateKey === today) {
      if (!liveStatusMap.has(tableName)) {
        liveStatusMap.set(tableName, {
          tableName,
          totalRecordCount: 0,
          lastSyncDateTime: '',
          lastSyncRecordCount: 0,
          lastSyncStatus: '',
        });
      }

      const statusObj = liveStatusMap.get(tableName)!;
      statusObj.totalRecordCount += record.recordcount;

      if (!statusObj.lastSyncDateTime || dayjs(record.taskdate).isAfter(statusObj.lastSyncDateTime)) {
        statusObj.lastSyncDateTime = record.taskdate;
        statusObj.lastSyncRecordCount = record.recordcount;
        statusObj.lastSyncStatus = record.status.toUpperCase();
      }
    }
  }

  const tableWise = Object.values(tableWiseData).map(({ taskDate, groupItems }) => ({
    taskDate,
    groupItems: JSON.stringify(groupItems),
  }));

  return {
    tableWise,
    liveStatus: Array.from(liveStatusMap.values())
  };
};

